<template>
    <div style="margin: 10px 30px 0px">
      <div v-if="isAdd">
        <el-steps :active="activeIndex" align-center>
          <el-step :title="activeIndex === 1 ? '进行中' : '已完成'" description="新建服务商" icon="el-icon-circle-plus-outline"></el-step>
          <el-step :title="activeIndex === 2 ? '进行中' : '等待中'" description="绑定服务内容" icon="el-icon-document-copy"></el-step>
        </el-steps>
      </div>
      <div v-if="activeIndex === 1">
        <el-form style="margin: 10px 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
          <el-row>
            <el-col :span="17">
              <el-form-item label="服务商名称" prop="name">
                <el-input v-model="addEditForm.name" placeholder="请输入服务商名称"></el-input>
              </el-form-item>
              <el-form-item label="服务商地址" prop="address">
                <el-input type="textarea" :rows="2" placeholder="请输入服务商地址" v-model="addEditForm.address" @blur="testAddress()">
                </el-input>
              </el-form-item>
              <el-form-item label="服务商电话" prop="telephone">
                <el-input type="number" v-model="addEditForm.telephone" placeholder="请输入服务商电话"></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="">
                <el-input v-model="addEditForm.contact_person" placeholder="请输入联系人"></el-input>
              </el-form-item>
              <el-form-item label="联系人电话" prop="">
                <el-input type="number" v-model="addEditForm.contact_telephone" placeholder="请输入联系人电话"></el-input>
              </el-form-item>
              <el-form-item label="所属组织" prop="orgid">
                <el-cascader v-fixZoom style="width: 100%" :options="treeData" v-model="addEditForm.orgid" :filterable="true" placeholder="请选择所属组织"
                             :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}" ref="orgOptions">
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <div style="width: 90px;margin: auto">
                <el-upload class="avatar-uploader" action="#" :auto-upload="false"
                           :show-file-list="false" :on-exceed="handleExceed" :before-upload="beforeUpload"
                           :on-change="getFile" list-type="picture" :file-list="fileList" ref="uploadavatar">
                  <img v-if="addEditForm.business_license" :src="addEditForm.business_license" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div style="font-size: 16px;text-align: center;color: #409EFF">
                <span>营业执照</span>
              </div>
              <div style="font-size: 14px;text-align: center;color: #999999"><span>jpeg/jpg/png格式</span></div>
            </el-col>
          </el-row>
        </el-form>
        <div>
          <el-row style="margin: 0 30px">
            <el-col :span="12">
              <div class="cancel-btn" @click="closeAdd()"><span>取消</span></div>
            </el-col>
            <el-col :span="12">
              <div class="send-btn" @click="submitAddEdit('addEditForm')"><span>确定</span></div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-if="activeIndex === 2" style="max-height: 420px">
        <div  style="margin-top: 10px;text-align: left;height: 50px">
          <el-button icon="el-icon-circle-plus-outline" size="small" type="primary" @click="addTypeOpen()">绑定服务内容</el-button>
        </div>
        <div style="max-height: 360px;overflow-y: auto">
          <el-table height="360px" :data="tableContent" border highlight-current-row ref="singleTable" size="mini">
            <el-table-column
              prop="service_name"
              label="服务内容"
              min-width="90"
              align="center">
            </el-table-column>
            <el-table-column
              label="服务类型"
              min-width="70"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.st_id !== 0">{{getUpTypeName(scope.row.st_id)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="time_duration"
              label="服务时长(分钟)"
              min-width="100"
              align="center">
            </el-table-column>
            <el-table-column
              label="服务价格"
              min-width="70"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.price !== ''">{{parseFloat(scope.row.price) / 100}}元</span>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-if="false" ref="multipleTable" tooltip-effect="dark" :data="serviceTypeArr" border highlight-current-row size="mini" @selection-change="handleSelectionChange">
            <!--          <el-table height="360px" :data="showContent" border highlight-current-row ref="singleTable" size="mini">-->
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="typename" label="服务类型" min-width="70" align="center"></el-table-column>
            <el-table-column label="上级类型" min-width="90" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.upid !== 0">{{getUpTypeName(scope.row.upid)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="服务时长(分钟)" min-width="90" align="center">
              <template slot-scope="scope">
                <input style="height: 26px;width: 100%;border: #999999 1px solid;padding: 0 5px;box-sizing: border-box" type="number" v-model="scope.row.timeDuration" placeholder="请输入时长（分钟）"/>
              </template>
            </el-table-column>
            <el-table-column label="服务价格" min-width="90" align="center">
              <template slot-scope="scope">
                <input style="height: 26px;width: 100%;border: #999999 1px solid;padding: 0 5px;box-sizing: border-box" type="number" v-model="scope.row.onPrice" placeholder="请输入价格（元）" />
              </template>
            </el-table-column>
          </el-table>
        </div>
<!--        <div  style="margin-top: 10px;text-align: right;height: 50px">-->
<!--          <div class="send-btn" @click="bindContent"><span>确定绑定</span></div>-->
<!--        </div>-->
      </div>
      <div v-if="activeIndex === 1" style="height: 30px"></div>
      <el-dialog width="550px" :title="addEditForm.name + '-绑定服务内容'" v-if="addEditContentShow" :visible.sync="addEditContentShow" append-to-body>
        <add-edit-scontent v-model="addEditContentShow" :addEdit="addContent" @changeUpadte="dataUpdate"></add-edit-scontent>
      </el-dialog>
    </div>
</template>

<script>
import {addsupplierorg, addsupplierservice, querysupplierservice, updatesupplierorg} from '../../../api/serviceMark'
import addEditScontent from '../../servicemanagement/childComponents/addEditScontent'
import {uploadfile} from '../../../api/yanglaoyuan'
export default {
  name: 'addEditService',
  model: {
    prop: 'addEditSupplierShow',
    event: 'change'
  },
  props: {
    addEdit: {
      type: Object,
      default: null
    }
  },
  components: {addEditScontent},
  data () {
    return {
      fileList: [],
      orgData: [],
      isAdd: true,
      treeData: [],
      addEditForm: {
        id: '',
        name: '',
        address: '',
        telephone: '',
        orgid: '',
        contact_person: '',
        contact_telephone: '',
        business_license: ''
      },
      addEditRules: {
        name: [{ required: true, message: '请输入服务商名称', trigger: 'blur' }],
        address: [{ required: true, message: '请输入服务商地址', trigger: 'blur' }],
        telephone: [{ required: true, message: '请输入服务商电话', trigger: 'blur' }],
        orgid: [{ required: true, message: '请输入选择所属组织', trigger: 'change' }]
      },
      supplierId: '', // 添加返回的服务商id
      activeIndex: 1,
      tableContent: [],
      serviceTypeArr: [],
      multipleSelection: [],
      // typeTree: [],
      typeId: '',
      otherid: '',
      selectType: '',
      types: [],
      showContent: [],
      addEditContentShow: false,
      addContent: {
        isAdd: true,
        isService: true, // 是否为具体服务商绑定服务内容
        supplierId: '', // 服务商id
        serviceRow: '', // 服务内容id
        orgid: '',
        allSupplier: [],
        types: [],
        orgData: []
      }
    }
  },
  created () {
    if (this.addEdit.isAdd) {
      this.querySupplierTypeData()
    }
    this.getData()
  },
  methods: {
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeUpload (file) {
      console.log(111, file, file.type)
    },
    getFile (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '营业执照',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传', type: 'success' })
        this.addEditForm.business_license = res.data.fileurl
      }).catch(() => {
        this.$message.closeAll()
        this.addEditForm.business_license = ''
        this.$message({ message: '上传失败', type: 'error' })
      })
    },

    handleSelectionChange (val) {
      console.log(val)
      this.multipleSelection = val
    },
    dataUpdate (obj) {
      this.$emit('updateTableSupp')
      this.querySupplierAndType()
      this.addEditContentShow = false
    },
    // 服务内容
    querySupplierAndType () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        so_id: this.supplierId
      }
      querysupplierservice(params, data).then(res => {
        this.tableContent = res.data.service
      }).catch(() => {})
    },
    // 服务类型
    querySupplierTypeData () {
      this.types = this.addEdit.types
      let arr = []
      for (let i = 0; i < this.types.length; i++) {
        let obj = this.types[i]
        if (obj.is_service === 1) {
          obj.onPrice = ''
          obj.timeDuration = ''
          arr.push(obj)
        }
      }
      this.serviceTypeArr = arr
      this.addContent.types = this.addEdit.types
      this.addContent.orgData = this.orgData
      // console.log(this.serviceTypeArr)
    },
    getData () {
      this.orgData = this.addEdit.orgData
      this.isAdd = this.addEdit.isAdd
      // 所属组织
      let lastLevel = 100
      const arr = this.orgData
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.treeData.push(arr[i])
        }
      }
      for (let i = 0; i < this.treeData.length; i++) {
        const child = this.arrayToNode(arr, this.treeData[i].id)
        if (child.length !== 0) {
          this.treeData[i].child = child
        }
      }
      if (this.isAdd) {
        this.addEditForm.id = 0
      } else {
        this.addEditForm.id = this.addEdit.row.id
        this.addEditForm.name = this.addEdit.row.name
        this.addEditForm.address = this.addEdit.row.address
        this.addEditForm.telephone = this.addEdit.row.telephone
        this.addEditForm.orgid = this.addEdit.row.orgid
        this.addEditForm.contact_person = this.addEdit.row.contact_person
        this.addEditForm.contact_telephone = this.addEdit.row.contact_telephone
        this.addEditForm.business_license = this.addEdit.row.business_license
      }
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    closeAdd () {
      this.$emit('change', false)
    },
    testAddress () {
      this.addEditForm.address = this.addEditForm.address.replace(/[\r\n]/g, '')
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            addsupplierorg(this.addEditForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功添加服务商',
                type: 'success',
                duration: 2000
              })
              this.supplierId = res.data.newobjid
              this.addContent.supplierId = res.data.newobjid
              this.addContent.orgid = this.addEditForm.orgid
              // this.golobleObject.updateTableSupp()
              this.$emit('updateTableSupp')
              this.querySupplierAndType()
              this.activeIndex = 2
              // this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '添加服务商失败'
              })
            })
          } else {
            updatesupplierorg(this.addEditForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功修改服务商',
                type: 'success',
                duration: 2000
              })
              // this.golobleObject.updateTableSupp()
              this.$emit('updateTableSupp')
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '修改服务商失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 绑定服务内容
    async bindContent () {
      for (let i = 0; i < this.multipleSelection.length; i++) {
        let price = this.multipleSelection[i].onPrice === '' ? '' : parseFloat(this.multipleSelection[i].onPrice) * 100
        let data = {
          'id': 0,
          'so_id': this.supplierId,
          'st_id': this.multipleSelection[i].id,
          'service_name': this.multipleSelection[i].typename,
          'orgid': this.addEditForm.orgid,
          'time_duration': this.multipleSelection[i].timeDuration,
          'price': price + '',
          is_have_type: 1,
          up_level: this.multipleSelection[i].level,
          up_id: this.multipleSelection[i].upid
        }
        await addsupplierservice(data).then(res => {
        }).catch(() => {
          this.$notify.error({ title: '失败', message: '绑定服务内容失败' })
        })
      }
      this.$emit('updateTableSupp')
      this.$emit('change', false)
    },
    getUpTypeName (upid) {
      let name = ''
      let upids = this.getOrgName1(parseInt(upid), [])
      for (let i = 0; i < upids.length; i++) {
        for (let j = 0; j < this.types.length; j++) {
          if (parseInt(upids[i]) === this.types[j].id) {
            name = this.types[j].typename + ' / ' + name
          }
        }
      }
      return name !== '' ? name.substring(0, name.length - 3) : ''
    },
    getOrgName1 (upid, arr) {
      arr.push(upid)
      for (let i = 0; i < this.types.length; i++) {
        if (parseInt(upid) === this.types[i].id) {
          arr = this.getOrgName1(this.types[i].upid, arr)
        }
      }
      return arr
    },
    addTypeOpen () {
      this.addEditContentShow = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/serviceprovider/childComponents/addEditService.vue